import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as imageOptimizerAction from '../actions/image-optimizer.action';
import {first, map, switchMap} from 'rxjs/operators';
import {Store} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {BoosterService} from "../../websites/website/booster/services/booster.service";
import {DbResponse} from "../../shared/interceptors/db-response";
import {LoadImageOptimizer, LoadImageOptimizerAutoOptimize} from "../actions";
import {BoosterStats} from "../../websites/website/booster/front-end/optimize-images/models/booster-stats.model";

@Injectable()
export class ImageOptimizerEffect {

  loadImageOptimizerData = createEffect(() => this._actions$.pipe(
    ofType(imageOptimizerAction.LOAD_IMAGE_OPTIMIZER),
    switchMap((action: LoadImageOptimizer) => {
      return this._boosterService.getOptimizerStats(action.payload.websiteId)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              const stats = new BoosterStats(response.data);
              return new imageOptimizerAction.LoadImageOptimizerSuccess({
                websiteId: action.payload.websiteId,
                stats: stats
              });
            }
            return new imageOptimizerAction.LoadImageOptimizerFail({websiteId: action.payload.websiteId});
          })
        );
    })
  ));

  loadImageOptimizerAutoOptimize = createEffect(() => this._actions$.pipe(
    ofType(imageOptimizerAction.LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE),
    switchMap((action: LoadImageOptimizerAutoOptimize) => {
      return this._boosterService.optimizerSettingsGet(action.payload.websiteId)
        .pipe(
          first(response => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new imageOptimizerAction.LoadImageOptimizerAutoOptimizeSuccess(
                {
                  websiteId: action.payload.websiteId,
                  autoOptimizeEnabled: !!response.data.enable_auto_optimization
                });
            }
            return new imageOptimizerAction.LoadImageOptimizerAutoOptimizeFail({websiteId: action.payload.websiteId});
          })
        );
    })
  ));
  constructor(
    private _store: Store<DbStoreState>,
    private _actions$: Actions,
    private _boosterService: BoosterService,
  ) {
  }
}
